import { Container } from "inversify";
import "reflect-metadata";

import {Voiceover} from './voiceover'
import {Synchroniser} from './Synchroniser'
import {AnimationPlugin} from './Animation/AnimationPlugin'
import {ClosedCaptionsService} from './ClosedCaptionsService'
import {CustomerCustomisationPlugin} from "./CustomerCustomisationPlugin"
import StringLocaliser from "./i18n/StringLocaliser";
import getCulture from "./i18n/CurrentCulture";
import {SettingsService} from "./Core/Settings";
import {Slideshow} from "@/slideshow";
import {PubSub} from "@/Core/PubSub";
import {TutorialState} from "@/Core/TutorialState";

let kernel = new Container();

kernel.bind<Slideshow>("Slideshow").to(Slideshow).inSingletonScope();
kernel.bind<PubSub>("PubSub").to(PubSub).inSingletonScope();
kernel.bind<AnimationPlugin>("AnimationPlugin").to(AnimationPlugin).inSingletonScope();
kernel.bind<Voiceover>("Voiceover").to(Voiceover).inSingletonScope();
kernel.bind<Synchroniser>("Synchroniser").to(Synchroniser).inSingletonScope();
kernel.bind<TutorialState>("TutorialState").to(TutorialState).inSingletonScope();

kernel.bind<CustomerCustomisationPlugin>("SlideshowPlugin").to(CustomerCustomisationPlugin).inSingletonScope().whenTargetNamed("CustomerCustomisationPlugin");

kernel.bind<SettingsService>("SettingsService").to(SettingsService).inSingletonScope();
kernel.bind<ClosedCaptionsService>("ClosedCaptionsService").to(ClosedCaptionsService).inSingletonScope();

kernel.bind<StringLocaliser>("StringLocaliser").toConstantValue(new StringLocaliser(getCulture()));

export default kernel;